<template>
  <div class="sticky-navigation" :class="{ fixed, stay }">
    <button @click.prevent="goTo(section.id)" :class="{ current: active === section.id }" :key="section.id" v-for="section in sections">
      <span class="counter"></span><span class="title">{{ section.sectionTitle }}</span>
    </button>
  </div>
</template>

<script>
import { TweenLite, Power2 } from 'gsap'
export default {
  props: {
    sections: { type: Array, required: true },
    active: { type: String }
  },
  data: () => ({
    dimensions: {},
    fixed: false,
    stay: false,
    start: performance.now()

  }),
  created () {
    window.addEventListener('resize', this.setDimensions)
    window.addEventListener('scroll', this.setPosition, { passive: true })
  },
  beforeDestroy () {
    window.cancelAnimationFrame(this.rAF)
    window.removeEventListener('resize', this.setDimensions)
    window.removeEventListener('scroll', this.setPosition, { passive: true })
  },
  async mounted () {
    await this.$nextTick()
    this.setDimensions()
  },
  methods: {
    goTo (id) {
      TweenLite.to(window, 0.255, {
        onUpdate: () => {
          this.setPosition()
        },
        ease: Power2.easeOut,
        scrollTo: {
          y: `section[data-id="${id}"]`,
          offsetY: this.dimensions.winHeight * 0.35
        }
      })
    },
    setPosition (e) {
      if ((performance.now() - this.start) < 1000) {
        setTimeout(this.setPosition, Math.max(1000 - (performance.now() - this.start), 0))
        return
      }

      let offsetTop = window.scrollY - this.dimensions.x1
      let offsetBottom = window.scrollY - this.dimensions.x2

      this.fixed = offsetTop >= 0
      this.stay = offsetBottom > 0

      if (this.stay) {
        this.$el.style.top = this.dimensions.x2 + 255.25 + (this.dimensions.height / 2) + 'px'
      } else {
        this.$el.style.top = null
      }
    },
    setDimensions () {
      this.dimensions = Object.assign({}, this.$el.getBoundingClientRect().toJSON())
      this.dimensions.winHeight = window.innerHeight
      let centerY = ((this.dimensions.winHeight - this.dimensions.height) / 2)
      this.dimensions.x1 = (this.dimensions.top + window.scrollY) - centerY

      let last = Array.from(document.querySelectorAll('main section.content-section')).pop().getBoundingClientRect()
      this.dimensions.x2 = (window.scrollY + last.bottom) - centerY - 255.25

      if (!this.fixed && (performance.now() - this.start) < 10000) {
        this.rAF = window.requestAnimationFrame(this.setDimensions)
      }
    }
  }
}
</script>

<style lang="scss">
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';

body {
  counter-reset: sticky-counter;
}

.sticky-navigation {
  display: none;

  @media #{$above-breakpoint-1280} {
    display: flex;
    flex-direction: column;

    position: absolute;
    z-index: 1;
    left: 20px;
    top: calc(600px + 25vh);

    &.fixed {
      position: fixed;
      top: 50%;
      transform: translateY(-50%);
    }

    &.stay {
      position: absolute !important;
    }
  }
}
.sticky-navigation button {
  display: flex;
  align-items: center;

  font-size: 14px;
  color: $color-black;

  margin-bottom: $global-padding;

  &:before {
    content: "";
    height: 8px;
    width: 8px;
    border-radius: 50%;

    margin-right: $global-padding / 2;

    display: block;

    background-color: $color-grey-x;
  }

  &:hover {
    &:before {
      background-color: $color-red;
    }

    .counter:before {
      color: $color-red;
    }
  }

  &.current {
    color: $color-red;
    margin-left: $global-padding;

    &:before {
      background-color: $color-red;
      height: 10px;
      width: 10px;
    }
  }
}

.sticky-navigation .counter {
  counter-increment: sticky-counter;
}

.sticky-navigation .counter:before {
  content: counters(sticky-counter, ".", decimal-leading-zero);
  font-size: 12px;
  margin-right: $global-padding / 2;
}

.sticky-navigation .title {
  @media #{$below-breakpoint-1440} {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/sticky-nav.vue